<template>
  <div class="orderReport">
    <div class="select">
      <table>
        <tr>
          <td>
            <div class="block">
              <el-date-picker
                v-model="startTime"
                type="date"
                placeholder="开始日期">
              </el-date-picker>
            </div>
          </td>
          <td>
            <div class="block">
              <el-date-picker
                v-model="startTime"
                type="date"
                placeholder="结束日期">
              </el-date-picker>
            </div>
          </td>
          <td>
            <el-button style="background-color: #FF9000; color: #FFFFFF; margin-left: 30px;" icon="el-icon-search">搜索
            </el-button>
            <el-button type="info" class="el-icon-delete">清空</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="date"
          label="日期"
          align="center">
        </el-table-column>
        <el-table-column
          prop="date"
          label="订单笔数"
          align="center">
        </el-table-column>
        <el-table-column
          prop="date"
          label="微信订单笔数"
          align="center">
        </el-table-column>
        <el-table-column
          prop="date"
          label="微信订单金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="date"
          label="支付宝订单笔数"
          align="center">
        </el-table-column>
        <el-table-column
          prop="date"
          label="支付宝订单金额"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-size="100"
        layout="total, prev, pager, next, jumper"
        :total="400">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderReport'
}
</script>

<style scoped>
.orderReport {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.select {
  width: 70%;
  margin: auto;
}

.data {
  margin-top: 20px;
  width: calc(100% - 30px);
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/reportmanagement/orderreport.vue